export const BASE_PORTFOLIOS_PATH = "portfolios";

export const PORTFOLIOS_ROUTES = {
  PORTFOLIO: "portfolio",
};

export const PORTFOLIO_ROUTES = {
  ADD: "add",
};

export const ADD_PORTFOLIO_ROUTES = {
  CONFIGURATION: "configuration",
  CONFIGURATION_SUCCESS: "configuration-success",
  COMMUNITIES: "communities",
};
